import { Images } from "../../utils/imageConstants";
import type { NoDataFoundProps } from "../types/common";


const NoDataFound: React.FC<NoDataFoundProps> = ({ 
  message = "NO MATCHES FOUND",
  className = ""
}) => {
  return (
    <div className={`no-data-found ${className}`}>
      <img 
        src={Images.my_leagues_no} 
        className="no-data-image" 
        alt="no-data-image"
      /> 
      <p>{message}</p>
    </div>
  );
};

export default NoDataFound;


